import { render, staticRenderFns } from "./CreateBookModal.vue?vue&type=template&id=22de3989&scoped=true&"
import script from "./CreateBookModal.vue?vue&type=script&lang=js&"
export * from "./CreateBookModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateBookModal.vue?vue&type=style&index=0&id=22de3989&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de3989",
  null
  
)

export default component.exports